import React, { PureComponent } from 'react';

import { injectIntl, defineMessages } from 'react-intl';

import { SimpleTimePicker } from 'components';
import { Divider, Segment, Checkbox, Input, Popup, Button, Image } from 'semantic-ui-react';

import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './ReactTableFilterDatePicker.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));

class ReactTableFilterDatePicker extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      popupIsOpen: false,
      startDate: null,
      endDate: null,
      selectedRecentDate: null,
      fromNow: false,
      timeObj: {
        startTime: { hour: 0, minute: 0, second: 0 },
        endTime: { hour: 23, minute: 59, second: 59 }
      }
    };
  }

  handlerecentDateChange = (e, { value }) => {
    this.setState({
      startDate: null,
      endDate: null,
      selectedRecentDate: value
    });
  };

  handleSearchCustomDate = () => {
    // 필터 적용
    const { selectedRecentDate, startDate, endDate, fromNow } = this.state;
    const { onChange } = this.props;

    const dateFilter = {
      startDate: null,
      endDate: null,
      selectedRecentDate: null,
      fromNow: fromNow,
      reload: 1
    };

    if (selectedRecentDate) {
      // 최근 시리즈 (라디오 버튼)
      dateFilter.selectedRecentDate = selectedRecentDate;
      if (selectedRecentDate === 'recentWeek') {
        dateFilter.startDate = moment()
          .subtract(1, 'weeks')
          .unix()
          .toString();
      } else if (selectedRecentDate === 'recentMonth') {
        dateFilter.startDate = moment()
          .subtract(1, 'months')
          .unix()
          .toString();
      } else if (selectedRecentDate === 'recentYear') {
        dateFilter.startDate = moment()
          .subtract(1, 'years')
          .unix()
          .toString();
      } else {
        // ?
      }
    } else {
      // 기간 지정 시 시작일자 와 끝 일자 중 1개 이상 입력된 경우
      if (startDate || endDate) {
        if (startDate) {
          dateFilter.startDate = startDate.unix().toString();
        }
        if (endDate) {
          dateFilter.endDate = endDate.unix().toString();
        }
      } else {
        // ?
      }
    }

    this.setState({ popupIsOpen: false });

    onChange(dateFilter);
  };

  handleResetCustomDate = () => {
    // 필터 초기화
    const { onChange } = this.props;

    this.setState({
      selectedRecentDate: null,
      startDate: null,
      endDate: null,
      popupIsOpen: false
    });

    onChange({ fromNow: this.state.fromNow, reload: 1 });
  };

  // handleFromNowOnCheck = (e, data) => {
  //   const { filter, onChange } = this.props;

  //   this.setState({ fromNow: data.checked });

  //   const dateFilter = {
  //     startDate: filter && filter.value && filter.value.startDate ? filter.value.startDate : null,
  //     endDate: filter && filter.value && filter.value.endDate ? filter.value.endDate : null,
  //     selectedRecentDate:
  //       filter && filter.value && filter.value.selectedRecentDate ? filter.value.selectedRecentDate : null,
  //     fromNow: data.checked,
  //     reload: 0
  //   };

  //   onChange(dateFilter);
  // };

  handlePopupOpen = e => {
    e.stopPropagation();
    this.setState({ popupIsOpen: true });
  };

  handlePopupClose = e => {
    e.stopPropagation();
    this.setState({ popupIsOpen: false });
  };

  handleDatePickerOnChangeStart = (date, e) => {
    if (!!!date) {
      return false;
    }
    const { timeObj } = this.state;

    date
      .hour(timeObj.startTime.hour)
      .minute(timeObj.startTime.minute)
      .second(0);

    const dateObj = {
      selectedRecentDate: null,
      startDate: date
    };
    if (date > this.state.endDate) {
      // 시작 날짜를 종료 날짜 이후로 선택한 경우
      // 종료 날짜를 초기화 해준다.
      dateObj.endDate = null;
    }
    this.setState(dateObj);
  };

  handleDatePickerOnChangeEnd = (date, e) => {
    if (!!!date) {
      return false;
    }
    const { timeObj } = this.state;

    date
      .hour(timeObj.endTime.hour)
      .minute(timeObj.endTime.minute)
      .second(59);

    this.setState({
      selectedRecentDate: null,
      endDate: date
    });
  };

  handleTimePickerOnChange = (name, data) => {
    const { timeObj } = this.state;

    if (timeObj[name]) {
      if (typeof data.hour !== 'undefined') {
        timeObj[name]['hour'] = data.hour;
      }
      if (typeof data.minute !== 'undefined') {
        timeObj[name]['minute'] = data.minute;
      }
      if (typeof data.second !== 'undefined') {
        timeObj[name]['second'] = data.second;
      }

      this.setState({ timeObj });
    }

    // 이미 날짜를 선택한 경우 시간을 업데이트
    if (name === 'startTime' && this.state.startDate !== null) {
      this.handleDatePickerOnChangeStart(this.state.startDate);
    } else if (name === 'endTime' && this.state.endDate !== null) {
      this.handleDatePickerOnChangeEnd(this.state.endDate);
    } else {
      //
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { selectedRecentDate, popupIsOpen, startDate, endDate, fromNow, timeObj } = this.state;
    const { filter, onChange, column } = this.props;
    const {
      handlePopupOpen,
      handlePopupClose,
      handlerecentDateChange,
      handleSearchCustomDate,
      handleResetCustomDate,
      handleDatePickerOnChangeStart,
      handleDatePickerOnChangeEnd,
      handleTimePickerOnChange,
      handleFromNowOnCheck
    } = this;

    const filterText = column.id ? column.id.charAt(0).toUpperCase() + column.id.slice(1) : '';
    const isFiltered =
      filter && filterText && (filter['start' + filterText] || filter['end' + filterText]) ? true : false;

    return (
      <div className={cx('react-table-date-filter')}>
        <Popup
          basic
          className={cx('react-table-filter-popup')}
          position="bottom left"
          on="click"
          open={popupIsOpen}
          onOpen={handlePopupOpen}
          onClose={handlePopupClose}
          trigger={
            <Image
              className={cx('react-table-date-icon')}
              src={'/img/table/ico_cal' + (isFiltered ? '_active' : '') + '.png'}
            />
          }>
          <Popup.Content>
            <Segment.Group>
              {/* <Segment basic className={cx('filter-submenu-box')}>
                <Checkbox
                  label="시간 차이로 보기"
                  name="fromNowView"
                  checked={fromNow}
                  onChange={handleFromNowOnCheck}
                />
              </Segment>
              <Divider fitted /> */}
              <Segment basic className={cx('filter-submenu-box')}>
                <div className={cx('filter-submenu-title')}>
                  {defineMessages(formatMessage({ id: 'ReactTableFilterDatePicker_1', defaultMessage: '기간 필터' }))}
                </div>
                <div className={cx('filter-predefined-date')}>
                  <Checkbox
                    radio
                    label={defineMessages(
                      formatMessage({ id: 'ReactTableFilterDatePicker_2', defaultMessage: '최근 일주일' })
                    )}
                    name="recentDate"
                    value="recentWeek"
                    checked={selectedRecentDate === 'recentWeek'}
                    onChange={handlerecentDateChange}
                    className={cx('filter-predefined-date-inner-radio')}
                  />
                  <Checkbox
                    radio
                    label={defineMessages(
                      formatMessage({ id: 'ReactTableFilterDatePicker_3', defaultMessage: '최근 한달' })
                    )}
                    name="recentDate"
                    value="recentMonth"
                    checked={selectedRecentDate === 'recentMonth'}
                    onChange={handlerecentDateChange}
                    className={cx('filter-predefined-date-inner-radio')}
                  />
                  <Checkbox
                    radio
                    label={defineMessages(
                      formatMessage({ id: 'ReactTableFilterDatePicker_4', defaultMessage: '최근 일년' })
                    )}
                    name="recentDate"
                    value="recentYear"
                    checked={selectedRecentDate === 'recentYear'}
                    onChange={handlerecentDateChange}
                    className={cx('filter-predefined-date-inner-radio')}
                  />
                </div>
              </Segment>
              <Divider fitted />
              <Segment basic className={cx('filter-submenu-box')}>
                <div className={cx('filter-submenu-title')}>
                  {defineMessages(formatMessage({ id: 'ReactTableFilterDatePicker_5', defaultMessage: '기간 지정' }))}
                </div>
                <div className={cx('filter-date-time-picker')}>
                  <div className={cx('filter-date-picker-title')}>{}</div>
                  <DatePicker
                    name="startDate"
                    locale={localStorage.getItem('language')}
                    todayButton="Today"
                    placeholderText="From"
                    shouldCloseOnSelect={false}
                    selectsStart
                    showYearDropdown
                    dropdownMode="select"
                    customInput={<Input size="mini" icon={{ name: 'calendar' }} iconPosition="left" />}
                    showMonthDropdown
                    dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY HH:mm' : 'YYYY-MM-DD HH:mm'}
                    className={cx('filter-date-picker')}
                    calendarClassName={cx('filter-date-picker-calendar')}
                    popperClassName={cx('filter-date-picker-popper')}
                    popperPlacement="right-end"
                    selected={startDate}
                    startDate={startDate}
                    //maxDate={endDate}
                    endDate={endDate}
                    onChange={handleDatePickerOnChangeStart}>
                    <SimpleTimePicker
                      name="startTime"
                      titleText={
                        defineMessages(
                          formatMessage({ id: 'ReactTableFilterDatePicker_6', defaultMessage: '시작 시간' })
                        ) + ': '
                      }
                      defaultValueHour="0"
                      defaultValueMinute="0"
                      timeObj={timeObj}
                      hideSecond
                      onChange={handleTimePickerOnChange}
                    />
                  </DatePicker>
                </div>
                <div className={cx('filter-date-time-picker')}>
                  <div className={cx('filter-date-picker-title')}>{}</div>
                  <DatePicker
                    name="toDate"
                    locale={localStorage.getItem('language')}
                    todayButton="Today"
                    placeholderText="To"
                    shouldCloseOnSelect={false}
                    selectsEnd
                    showYearDropdown
                    dropdownMode="select"
                    customInput={<Input size="mini" icon={{ name: 'calendar' }} iconPosition="left" />}
                    showMonthDropdown
                    dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY HH:mm' : 'YYYY-MM-DD HH:mm'}
                    className={cx('filter-date-picker')}
                    calendarClassName={cx('filter-date-picker-calendar')}
                    popperClassName={cx('filter-date-picker-popper')}
                    popperPlacement="right-end"
                    selected={endDate}
                    startDate={startDate}
                    minDate={startDate}
                    endDate={endDate}
                    onChange={handleDatePickerOnChangeEnd}>
                    <SimpleTimePicker
                      name="endTime"
                      titleText={
                        defineMessages(
                          formatMessage({ id: 'ReactTableFilterDatePicker_7', defaultMessage: '종료 시간' })
                        ) + ': '
                      }
                      defaultValueHour="23"
                      defaultValueMinute="59"
                      timeObj={timeObj}
                      hideSecond
                      onChange={handleTimePickerOnChange}
                    />
                  </DatePicker>
                </div>
              </Segment>
              <Divider fitted />
              <Segment basic className={cx('filter-button-box')}>
                <Button
                  size="small"
                  className={cx('filter-search-button')}
                  content={defineMessages(
                    formatMessage({ id: 'ReactTableFilterDatePicker_8', defaultMessage: '검색' })
                  )}
                  icon={{ name: 'search' }}
                  onClick={handleSearchCustomDate}
                />
                {/* <Button
                  size="small"
                  className={cx('filter-reset-button')}
                  content={defineMessages(
                    formatMessage({ id: 'ReactTableFilterDatePicker_9', defaultMessage: '필터 제거' })
                  )}
                  icon={{ name: 'filter' }}
                  onClick={handleResetCustomDate}
                /> */}
              </Segment>
            </Segment.Group>
          </Popup.Content>
        </Popup>
      </div>
    );
  }
}

export default injectIntl(ReactTableFilterDatePicker);



// WEBPACK FOOTER //
// ./src/script/components/common/ReactTableFilterDatePicker.js